import { render, staticRenderFns } from "./TeamDetailOld.vue?vue&type=template&id=6253a14b&scoped=true"
import script from "./TeamDetailOld.vue?vue&type=script&lang=js"
export * from "./TeamDetailOld.vue?vue&type=script&lang=js"
import style0 from "./TeamDetailOld.vue?vue&type=style&index=0&id=6253a14b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6253a14b",
  null
  
)

export default component.exports